import {Component, OnInit, ViewChild} from "@angular/core";

import {CadastroRegraComponent} from "../cadastro-regra/cadastro-regra.component";
import {GerenciadorRegistroComponent} from "../gerenciador-registro/gerenciador-registro.component";
import {MatTabChangeEvent} from "@angular/material/tabs";
import {PageService} from "../../shared/layout/services/page.service";
import {ToastService} from "maps-angular-components";
import {ImportacaoLoteComponent} from "../../shared/importacao-lote/importacao-lote.component";
import {TipoUpload} from "../../shared/importacao-lote/tipo-upload";
import {FuncaoModelosModalComponent} from "../../funcao/containers/funcao-modelos-modal/funcao-modelos-modal.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: "app-regra",
  templateUrl: "./regra-simples.component.html",
  styleUrls: ["./regra-simples.component.scss"],
})
export class RegraSimplesComponent implements OnInit {
  @ViewChild("cadastroRegra", { static: false }) cadastroRegra: CadastroRegraComponent;
  @ViewChild("gerenciadorRegistros", { static: false }) gerenciadorRegistros: GerenciadorRegistroComponent;
  @ViewChild("regraImportacaoLote", { static: false }) regraImportacaoLote: ImportacaoLoteComponent;


  constructor(private page: PageService, private toastService: ToastService, private dialog: MatDialog) {}
  readonly tipo: TipoUpload = TipoUpload.REGRA_SIMPLES;

  ngOnInit() {
    this.page.defineTitle("REGRA SIMPLES");
  }

  tabChanged($event: MatTabChangeEvent): void {
    if ($event.index === 0) {
      this.cadastroRegra.limparForm();
    } else if ($event.index === 2) {
      this.gerenciadorRegistros.limparForm();
    }
  }

    downloadModelo() {
      this.dialog.open(FuncaoModelosModalComponent, {
        data: {},
        width: "840px",
      });
    }
}
